import { router } from "@foretagsplatsen/widgetjs";
import { setConfiguration as setAccountingApplicationConfiguration } from "../accounting/app.js";
import { setConfiguration as setConfirmDeletionConfiguration } from "./widgets/dialogs/footers/footers.js";
import { setConfiguration as setErrorLoggerConfiguration } from "./errorLogger.js";
import { setConfiguration as setHyphenatorConfiguration } from "./hyphenator.js";
import { setConfiguration as setImageActionConfiguration } from "../models/wysiwygEditor/actions/ImageAction.js";
import { setConfiguration as setInSaveSpaceModeConfiguration } from "../accounting/forecastEditor/ForecastEditorDocumentState.js";
import { setConfiguration as setMigrateDocumentConfiguration } from "../external/login/migrateDocument.js";
import { setConfiguration as setNotificationConfiguration } from "./widgets/notifier/notifier.js";
import { setConfiguration as setPeriodReportConfiguration } from "../accounting/reports/periodReport/periodReportViewerDocument.js";
import { setConfiguration as setRepositoryBuilderConfiguration } from "./repositories/repositoryBuilders.js";
import session from "./session.js";

/**
 * Execute functions, passing various ways to configure the
 * application as parameter.
 *
 * This function is to be called by the application's main files with
 * the window.finsitHooks object.
 */
export function runHooks(hooks = [], options = {}) {
	const application = {
		options,
		session,
		setMigrateDocumentConfiguration,
		setHyphenatorConfiguration,
		setImageActionConfiguration,
		setNotificationConfiguration,
		setConfirmDeletionConfiguration,
		setAccountingApplicationConfiguration,
		setErrorLoggerConfiguration,
		setPeriodReportConfiguration,
		setInSaveSpaceModeConfiguration,
		setRepositoryBuilderConfiguration,
		router: router.getRouter(),
	};

	hooks.forEach((hook) => hook(application));
}
